import envConfig from '@hulu/env-config';

export const HELPFUL_TIPS_LINKS = {
  techSpec: `${envConfig.REACT_APP_HELP_CENTER_URL}article/Technical-specifications`,
  terms: 'https://www.disneycampaignmanager.com/disney-campaign-manager-terms/#ads-and-campaigns',
  learnMore: `${envConfig.REACT_APP_HELP_CENTER_URL}article/Quick-Fixes-for-Common-Ad-Rejections`,
  videoSpecs: 'https://www.disneycampaignmanager.com/creative-hub/tech-specs-for-video-ads/',
} as const;
